module.exports = "/_next/static/videos/slide-4-4e39ff49d4e731d272cf7a33dec0e110.webm";